import classNames from 'classnames'
import { CSSProperties } from 'react'

import styles from './Skeleton.module.scss'

interface IProps {
  className?: string
  height?: string | number
  width?: string | number
  border?: string
}

export const Skeleton = (props: IProps) => {
  const { className, height, width, border } = props

  const inlineStyles: CSSProperties = {
    width,
    height,
    borderRadius: border,
  }

  /* `data-skeleton` lets a loading curtain tell a half-drawn area from a ready one. */
  return (
    <div
      className={classNames(styles.skeleton, {}, [className])}
      style={inlineStyles}
      data-skeleton
    />
  )
}
